import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import './MarkdownContent.css';

/**
 * Resolve image src to full URL when it's a relative path (e.g. /api/uploads/content/xxx)
 */
function resolveImageUrl(src) {
  if (!src) return src;
  if (src.startsWith('http://') || src.startsWith('https://') || src.startsWith('data:')) return src;
  const base = window.location.origin;
  return `${base}${src.startsWith('/') ? '' : '/'}${src}`;
}

/**
 * Custom list item renderer: unwraps a single <p> child so we get minimal spacing
 * between bullet points (no extra block wrapper).
 */
function ListItem({ children, ...props }) {
  const arr = React.Children.toArray(children);
  if (arr.length === 1 && arr[0]?.type === 'p') {
    return <li {...props}>{arr[0].props.children}</li>;
  }
  return <li {...props}>{children}</li>;
}

export default function MarkdownContent({ content, className = '' }) {
  if (!content) return null;
  const normalizedContent = content.replace(/\r\n/g, '\n').replace(/\n[ \t]+\n/g, '\n\n');

  return (
    <div className={`markdown-content ${className}`}>
      <ReactMarkdown
        remarkPlugins={[remarkGfm]}
        components={{
          li: ListItem,
          a: ({ href, children, ...props }) => (
            <a href={href} target="_blank" rel="noopener noreferrer" {...props}>
              {children}
            </a>
          ),
          img: ({ src, alt, ...props }) => (
            <img src={resolveImageUrl(src)} alt={alt || ''} loading="lazy" {...props} />
          )
        }}
      >
        {normalizedContent}
      </ReactMarkdown>
    </div>
  );
}
